/**
 * @param {InterviewServerState|undefined} state
 * @returns {InterviewServerState}
 */
export function initInterviewServerState(state = {}) {
    return {
        ...(state || {}),

        socket: state?.socket || null,

        peerOptions: { ...(state?.peerOptions || {}) },
        peers: { ...(state?.peers || {}) },

        seekers: [...(state?.seekers || [])].map(initInterviewServerState__Seeker),
    };
}

/**
 * @typedef InterviewServerState
 * @property {import("socket.io-client").Socket|null}       socket      소켓
 * @property {SocketId}                                     socketId    세션 ID
 *
 * @property {import("simple-peer").Options}                peerOptions 피어 옵션
 *
 * @property {Object.<string,InterviewServerState__Peer>}   peers       피어 Object
 * @property {InterviewServerState__Seeker[]}               seekers     참여요청
 */

/**
 * @param {InterviewServerState__Peer|undefined} peer
 * @returns {InterviewServerState__Peer}
 */
export function initInterviewServerState__Peer(peer = {}) {
    return {
        ...(peer || {}),

        _id: peer?._id || null,
        name: peer?.name || null,
        username: peer?.username || null,
        socketId: peer?.socketId || null,

        peer: peer?.peer || null,
        stream: peer?.stream || null,

        enabled_audio: undefined,
        enabled_video: undefined,
    };
}

/**
 * @typedef InterviewServerState__Peer
 *
 * @property {Name} name
 * @property {Username} username
 * @property {SocketId} socketId
 *
 * @property {import ("simple-peer").Instance|null} peer
 * @property {MediaStream|null} stream
 *
 * @property {boolean} enabled_audio 오디오 활성화
 * @property {boolean} enabled_video 비디오 활성화
 */

/**
 * @param {InterviewServerState__Seeker|undefined} seeker
 * @returns {InterviewServerState__Seeker}
 */
export function initInterviewServerState__Seeker(seeker = {}) {
    return {
        ...(seeker || {}),
        _id: seeker?._id || null,
        name: seeker?.name || null,
        username: seeker?.username || null,
        socketId: seeker?.socketId || null,
    };
}

/**
 * @typedef InterviewServerState__Seeker
 * @property {Id} _id
 * @property {Name} name
 * @property {Username} username
 * @property {SocketId} socketId
 */

/** @typedef {string|null} Id 사용자 인덱스 */
/** @typedef {string|null} Name 사용자 이름 */
/** @typedef {string|null} Username 사용자 아이디 */
/** @typedef {string|null} SocketId 세션 아이디 */
